module.exports = __webpack_public_path__ + "static/media/warning.0ca149b5.svg";